import { render, staticRenderFns } from "./UserRoleListDropdown.vue?vue&type=template&id=7fc4ac1c&"
import script from "./UserRoleListDropdown.vue?vue&type=script&lang=js&"
export * from "./UserRoleListDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports